import { ConfigProvider } from "antd";
import { Routes, Route, useLocation } from "react-router-dom";
import Landing from './pages/Landing/Landing';
import Maps from './pages/Maps/Maps';
import Analytics from "./pages/Analytics/Analytics";
import { KeepAlive } from "./components/KeepAlive";

function App() {
  const location = useLocation();

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#19346F',
        },
      }}
    >
      <Routes location={location}>
        <Route path="/" element={<Landing />} />
        <Route path="/analytics" element={<Analytics />} />
      </Routes>
      <KeepAlive active={location.pathname === "/maps"}>
        <Maps />
      </KeepAlive>
    </ConfigProvider>
  );
}

export default App;
